import * as Sentry from '@sentry/react';

import { config } from './config';

// DSN + environment come from runtime config (the #app-config island) so the
// build-once bundle reports the correct environment (staging vs production) and
// the DSN can rotate without a rebuild. `release` stays build-time — it
// identifies the artifact, not the deployment.
const dsn = config.sentryDsn;

if (dsn) {
  Sentry.init({
    dsn,
    environment: config.appEnv,
    release: import.meta.env.VITE_RELEASE,
    tracesSampleRate: 0.1,
    sendDefaultPii: true,
    enabled: import.meta.env.PROD,
    integrations: [
      Sentry.browserTracingIntegration(),
      Sentry.replayIntegration({
        maskAllText: false,
        blockAllMedia: false,
      }),
    ],
    replaysSessionSampleRate: 0,
    replaysOnErrorSampleRate: 1.0,
  });
}

export { Sentry };
